export const getTodayDate = (currentLanguage = 'es') => {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const today = new Date();
  const getDay = today.toLocaleDateString(currentLanguage, options);

  return getDay.split(',');
};
